import {
  IInformationTypeAccess,
  IInformationTypePermissionSet,
} from "../../models/informationType";
import { StoreState } from "../storeState";

export enum InformationTypeTypes {
  AVAILABLE_FETCH_REQUEST = "@@informationType/AVAILABLE_FETCH_REQUEST",
  AVAILABLE_FETCH_SUCCESS = "@@informationType/AVAILABLE_FETCH_SUCCESS",
  AVAILABLE_FETCH_ERROR = "@@informationType/AVAILABLE_FETCH_ERROR",
  PERMISSIONS_FETCH_REQUEST = "@@informationType/PERMISSIONS_FETCH_REQUEST",
  PERMISSIONS_FETCH_SUCCESS = "@@informationType/PERMISSIONS_FETCH_SUCCESS",
  PERMISSIONS_FETCH_ERROR = "@@informationType/PERMISSIONS_FETCH_ERROR",
  PERMISSIONS_RESET = "@@informationType/PERMISSIONS_RESET",
}

export interface IInformationTypeState {
  availableState: StoreState;
  available: IInformationTypeAccess[];
  permissionsState: StoreState;
  permissionSet: IInformationTypePermissionSet | null;
}
